import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import RadioOffSvg from './radioOff.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: () => void,
};

export const RadioOffIcon = (props: any) => <Icon component={RadioOffSvg} {...props} />;

export const RadioOffButton = ({ size = 'medium', iconSize = 24, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<RadioOffIcon width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
